export const MIN_VOLUNTEER_AGE = 12;
export const MAX_VOLUNTEER_AGE = 130;

import {
  differenceInYears,
  parseISO,
  startOfDay,
  parse,
  isValid,
  isBefore,
  isEqual
} from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export function getDateDisplay(date: Date, timeZoneId: string) {
  return {
    months: formatInTimeZone(date, timeZoneId, 'MMM'),
    dates: formatInTimeZone(date, timeZoneId, 'd'),
    year: formatInTimeZone(date, timeZoneId, 'yyyy')
  };
}

export function getAge(date: Date) {
  return differenceInYears(new Date(), date);
}

export function getStartOfDayFromCalendarDate(dateString: string) {
  // from yyyy-MM-dd to yyyy-MM-ddT00:00:00
  return startOfDay(parseISO(dateString));
}

export function getStartOfDayFromFormattedDateStr(
  dateString: string,
  format = 'MM/dd/yyyy'
) {
  const parsedDate = parse(dateString, format, new Date());
  return formatInTimeZone(parsedDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
}

export function formatUTCDateString(dateString: string, format = 'MM/dd/yyyy') {
  return formatInTimeZone(new Date(dateString), 'UTC', format);
}

export function isValidISOString(dateStr: string) {
  const date = parseISO(dateStr);
  return isValid(date);
}

export function isDatePastOrEqual(date: Date) {
  return isBefore(date, new Date()) || isEqual(date, new Date());
}

export function calculateAge(
  birthDate: string | null | undefined
): number | '—' {
  if (!birthDate) return '—';
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return '—';
  return differenceInYears(new Date(), birth);
}

export function formatShortDate(
  dateString: string | null | undefined,
  isUTC = false
): string {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(isUTC && { timeZone: 'UTC' })
  });
}
